import { createUseStyles } from 'react-jss';
import { color, fontSize, spacing } from '@blink/components';

export const useBorrowDetailsStyle = createUseStyles({
    breadcrumbs: {
        display: 'flex',
        alignItems: 'center',
        margin: `${spacing['10']} 0 ${spacing['08']}`,
        color: color.content.primary,
        fontSize: fontSize.lg,
        gap: spacing['03'],
    },
    content: {
        display: 'flex',
        justifyContent: 'center',
        gap: spacing['07'],
    },
});
